"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRAppInfo = void 0;
class XHRAppInfo {
    constructor(bankId, platform) {
        this.name = this.constructor.name;
        this.bankId = bankId;
        this.platform = platform;
    }
    async handleRequest(request) {
        request.headers = {
            ...request.headers,
            'app-info': `${this.bankId}-${this.platform} 0.0.0`,
        };
        return Promise.resolve(request);
    }
}
exports.XHRAppInfo = XHRAppInfo;
//# sourceMappingURL=xhrAppInfo.js.map